import axios, { AxiosError, AxiosResponse } from "axios";
import { useMutation, useQueryClient } from "react-query";
import { toast } from "react-toastify";
import { plantUrls } from "../../URL/ApplicationUrls";
import Plant from "../Plant";
import { MdmApiError } from "../../Errors/MdmApiError";
import { apiErrorNotificationToast } from "../../Errors/apiErrorNotificationToast";
import { namedQueryKeyWithId } from "../../ReactQuery/namedQueryKeyWithId";

export const useUpdatePlant = (plantId: number | string | undefined) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (plant: Plant) => {
      return axios.put<Plant>(plantUrls.plantWithId(plantId).apiUrl, plant);
    },
    onSuccess: async (response: AxiosResponse<Plant>) => {
      const plant = response.data;
      await queryClient.invalidateQueries(namedQueryKeyWithId("plants", plant.Id));
      toast.success(`Updating the plant with the Id ${plant.Id} was successful`);
    },
    onError: (error: AxiosError<MdmApiError>) => {
      apiErrorNotificationToast(error);
    },
  });
};
